import { useEffect } from 'react';

import ProjectWorksheetHeader from '../../components/ProjectWorksheetHeader';
import Worksheet from '../../components/Worksheet';
import WorksheetActionBar from '../../components/Worksheet/WorksheetActionBar';
import ProjectWorksheetProvider from './providers/ProjectWorksheetProvider';
import { useTutorials } from '~/hooks/providers/TutorialProvider';
import './styles.scss';

export default function ProjectWorksheet() {
  const { setTutorialContext } = useTutorials() as any;

  useEffect(() => {
    setTutorialContext({ page: 'worksheet', data: {} });
  }, []);

  return (
    <ProjectWorksheetProvider>
      <div className="worksheet-layout">
        <WorksheetActionBar />
        <div className="worksheet-layout__row">
          <div className="worksheet-layout__main">
            <Worksheet />
          </div>
          <ProjectWorksheetHeader />
        </div>
      </div>
    </ProjectWorksheetProvider>
  );
}
